"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _base = _interopRequireDefault(require("./base"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ArrowLeft = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(ArrowLeft, _Component);

  var _super = _createSuper(ArrowLeft);

  function ArrowLeft() {
    (0, _classCallCheck2["default"])(this, ArrowLeft);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(ArrowLeft, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_base["default"], this.props, /*#__PURE__*/_react["default"].createElement("g", {
        id: "arrow-left",
        transform: "translate(32.000000, 31.500000) scale(-1, 1) translate(-32.000000, -31.500000) translate(17.000000, 9.000000)"
      }, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M5.7,44.7 L1.2,40.3 C0.8,39.9 0.8,39.3 1.2,38.9 L17.6,23 L1.2,7 C0.8,6.6 0.8,6 1.2,5.5 L5.7,1.1 C6.1,0.7 6.8,0.7 7.2,1.1 L24.3,17.8 L28.8,22.2 C29.2,22.6 29.2,23.2 28.8,23.6 L24.2,28 L7.2,44.7 C6.8,45.1 6.1,45.1 5.7,44.7"
      })), ' ');
    }
  }]);
  return ArrowLeft;
}(_react.Component);

exports["default"] = ArrowLeft;
(0, _defineProperty2["default"])(ArrowLeft, "defaultProps", {
  height: '16px',
  predefinedClassName: 'data-ex-icons-arrowleft'
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21tb24vaWNvbnMvYXJyb3ctbGVmdC50c3giXSwibmFtZXMiOlsiQXJyb3dMZWZ0IiwicHJvcHMiLCJDb21wb25lbnQiLCJoZWlnaHQiLCJwcmVkZWZpbmVkQ2xhc3NOYW1lIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUdBOztBQUNBOzs7Ozs7SUFFcUJBLFM7Ozs7Ozs7Ozs7OztXQU1uQixrQkFBUztBQUNQLDBCQUNFLGdDQUFDLGdCQUFELEVBQVUsS0FBS0MsS0FBZixlQUNFO0FBQ0UsUUFBQSxFQUFFLEVBQUMsWUFETDtBQUVFLFFBQUEsU0FBUyxFQUFDO0FBRlosc0JBSUU7QUFBTSxRQUFBLENBQUMsRUFBQztBQUFSLFFBSkYsQ0FERixFQU1PLEdBTlAsQ0FERjtBQVVEOzs7RUFqQm9DQyxnQjs7O2lDQUFsQkYsUyxrQkFDRztBQUNwQkcsRUFBQUEsTUFBTSxFQUFFLE1BRFk7QUFFcEJDLEVBQUFBLG1CQUFtQixFQUFFO0FBRkQsQyIsInNvdXJjZXNDb250ZW50IjpbIi8vIFNQRFgtTGljZW5zZS1JZGVudGlmaWVyOiBNSVRcbi8vIENvcHlyaWdodCBjb250cmlidXRvcnMgdG8gdGhlIGtlcGxlci5nbCBwcm9qZWN0XG5cbmltcG9ydCBSZWFjdCwge0NvbXBvbmVudH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IEJhc2UsIHtCYXNlUHJvcHN9IGZyb20gJy4vYmFzZSc7XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIEFycm93TGVmdCBleHRlbmRzIENvbXBvbmVudDxQYXJ0aWFsPEJhc2VQcm9wcz4+IHtcbiAgc3RhdGljIGRlZmF1bHRQcm9wcyA9IHtcbiAgICBoZWlnaHQ6ICcxNnB4JyxcbiAgICBwcmVkZWZpbmVkQ2xhc3NOYW1lOiAnZGF0YS1leC1pY29ucy1hcnJvd2xlZnQnXG4gIH07XG5cbiAgcmVuZGVyKCkge1xuICAgIHJldHVybiAoXG4gICAgICA8QmFzZSB7Li4udGhpcy5wcm9wc30+XG4gICAgICAgIDxnXG4gICAgICAgICAgaWQ9XCJhcnJvdy1sZWZ0XCJcbiAgICAgICAgICB0cmFuc2Zvcm09XCJ0cmFuc2xhdGUoMzIuMDAwMDAwLCAzMS41MDAwMDApIHNjYWxlKC0xLCAxKSB0cmFuc2xhdGUoLTMyLjAwMDAwMCwgLTMxLjUwMDAwMCkgdHJhbnNsYXRlKDE3LjAwMDAwMCwgOS4wMDAwMDApXCJcbiAgICAgICAgPlxuICAgICAgICAgIDxwYXRoIGQ9XCJNNS43LDQ0LjcgTDEuMiw0MC4zIEMwLjgsMzkuOSAwLjgsMzkuMyAxLjIsMzguOSBMMTcuNiwyMyBMMS4yLDcgQzAuOCw2LjYgMC44LDYgMS4yLDUuNSBMNS43LDEuMSBDNi4xLDAuNyA2LjgsMC43IDcuMiwxLjEgTDI0LjMsMTcuOCBMMjguOCwyMi4yIEMyOS4yLDIyLjYgMjkuMiwyMy4yIDI4LjgsMjMuNiBMMjQuMiwyOCBMNy4yLDQ0LjcgQzYuOCw0NS4xIDYuMSw0NS4xIDUuNyw0NC43XCIgLz5cbiAgICAgICAgPC9nPnsnICd9XG4gICAgICA8L0Jhc2U+XG4gICAgKTtcbiAgfVxufVxuIl19